<template>
    <picture class="gallery__card__img-wrap">
        <source :srcset="gallerySize == 1 ? singleImageXl : (gallerySize == 4 || gallerySize == 2 ? wideImageXl : imageXl)" media="(min-width: 1920px)" />
        <source :srcset="gallerySize == 1 ? singleImageMd : (gallerySize == 4 || gallerySize == 2 ? wideImageMd : imageMd)" media="(min-width: 992px)" />
        <source :srcset="gallerySize == 1 ? singleImageXs : (gallerySize == 4 || gallerySize == 2 ? wideImageXs : imageXs)" media="(min-width: 853px)" />
        <img class="gallery__card__img" :src="imageDefault" :alt="alt" />
    </picture>
</template>

<script>
export default {
    props: {
        img: {
            type: Object,
            default: () => ({ src: 'default_image_path.png', alt: 'Default Alt Text' })
        },
        alt: {
            type: String,
            default: 'Default Alt Text'
        },
        imgClass: {
            type: String,
            default: 'gallery__card__img'
        },
        gallerySize: {
            type: Number,
            default: 0
        }
    },
    setup() {

        return {};
    },
    data() {
        return {

            singleImageXl : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=2113&height=893&crop=7${this.focalPoints()}`,
            singleImageMd : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=1579&height=670&crop=7${this.focalPoints()}`,
            singleImageXs : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=889&height=380&crop=7${this.focalPoints()}`,

            wideImageXl : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=1049&height=847&crop=7${this.focalPoints()}`,
            wideImageMd : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=782&height=631&crop=7${this.focalPoints()}`,
            wideImageXs : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=436&height=369&crop=7${this.focalPoints()}`,

            imageXl : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=694&height=859&crop=7${this.focalPoints()}`,
            imageMd : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=516&height=639&crop=7${this.focalPoints()}`,
            imageXs : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=286&height=354&crop=7${this.focalPoints()}`,
            imageDefault : `/admin/public/getimage.ashx?image=${this.img.PathUrlEncoded}&compression=100&width=419&height=519&crop=7${this.focalPoints()}`
        };
    },
    mounted() {

    },
    methods: {
        focalPoints() {
            if (this.img.FocalX || this.img.FocalY) {
                return `&x=${this.img.FocalX}&y=${this.img.FocalY}`;
            } else {
                return '';
            }
        }
    },
};
</script>
